/**
 * 規劃圖檢視／編輯離開後，CoreUI modal 或 JointJS 可能把 backdrop 留在 body，
 * 會以 fixed 全屏阻擋場域內容分頁點擊。
 */
export const PLOT_MODAL_BACKDROP_CLEANUP_MS = 340;

const PLOT_MODAL_BACKDROP_CLEANUP_DELAYS_MS = [0, 50, PLOT_MODAL_BACKDROP_CLEANUP_MS, 900, 1500];

const PLOT_WORKSPACE_STRAY_LAYER_SELECTORS = [
  '#paper',
  '#inspector',
  '#navigator',
  '.plot-replay-bar',
  '.plot-joint-chart-overlay-host',
  '.plot-workspace-topbar--floating',
  '.plot-view-topbar',
  '.plot-edit-topbar',
  '.plot-view-floating-update',
  '.plot-workspace-status-chip',
  '.joint-selection',
  '.selection-wrapper',
  '.joint-paper',
  '.joint-viewport',
  'c-header.plot-workspace-topbar',
].join(', ');

function plotWorkspaceIsActive(): boolean {
  return !!document.querySelector('app-plot-view, app-plot-edit');
}

function resetBodyModalScrollLock(): void {
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('padding-right');
  document.body.style.removeProperty('padding-left');
}

function isInsidePlotWorkspace(el: Element): boolean {
  return !!el.closest('app-plot-view, app-plot-edit');
}

function removeStrayPlotLayers(force = false): void {
  if (!force && plotWorkspaceIsActive()) {
    return;
  }
  document.querySelectorAll(PLOT_WORKSPACE_STRAY_LAYER_SELECTORS).forEach((el) => {
    if (!isInsidePlotWorkspace(el)) {
      el.remove();
    }
  });
}

function removeStrayModalBackdrops(): void {
  document.querySelectorAll('.modal-backdrop, .offcanvas-backdrop').forEach((el) => el.remove());
}

/** plot-view 銷毀後可能留在 body 的 .modal.show（非場域 panel 自身 modal） */
function removeOrphanPlotBodyModals(): void {
  if (plotWorkspaceIsActive()) {
    return;
  }
  document.querySelectorAll('body > .modal.show, body > c-modal.modal.show').forEach((el) => {
    if (el.closest('app-places-control-panel')) {
      return;
    }
    el.remove();
  });
}

export function purgeStrayPlotWorkspaceDom(options?: {
  /** 場域 panel 有開啟中的 modal 時保留 backdrop */
  keepBackdropWhenModalOpen?: boolean;
  forcePlotLayers?: boolean;
}): void {
  if (typeof document === 'undefined') {
    return;
  }

  if (!options?.keepBackdropWhenModalOpen) {
    removeStrayModalBackdrops();
    removeOrphanPlotBodyModals();
    if (!document.querySelector('.modal-backdrop, .offcanvas-backdrop')) {
      resetBodyModalScrollLock();
    }
  }

  document.querySelectorAll('.joint-context-toolbar, .joint-tooltip').forEach((el) => {
    if (!isInsidePlotWorkspace(el)) {
      el.remove();
    }
  });
  removeStrayPlotLayers(options?.forcePlotLayers ?? false);
}

export function schedulePlotWorkspaceDomCleanup(options?: {
  keepBackdropWhenModalOpen?: boolean;
  forcePlotLayers?: boolean;
  delayMs?: number[];
}): void {
  const delays = options?.delayMs ?? PLOT_MODAL_BACKDROP_CLEANUP_DELAYS_MS;
  if (typeof window === 'undefined') {
    purgeStrayPlotWorkspaceDom(options);
    return;
  }
  for (const delay of delays) {
    if (delay <= 0) {
      purgeStrayPlotWorkspaceDom(options);
    } else {
      window.setTimeout(() => purgeStrayPlotWorkspaceDom(options), delay);
    }
  }
  window.requestAnimationFrame(() => {
    purgeStrayPlotWorkspaceDom(options);
    window.requestAnimationFrame(() => purgeStrayPlotWorkspaceDom(options));
  });
}
